export class NumberUtils {
    public static reduceDecimal(arr:number[]):number {
        return Math.round(arr.reduce((partialSum, a) => partialSum + a, 0) * 100) /100
    }
}